
import Nav from 'react-bootstrap/Nav';
import { INavBarItem } from '../../../types/menu';

import NavItemComponent from "./NavItemComponent";
import { useTranslation } from 'react-i18next';

function MobileMenuComponent({items}:any) {

  const { t } = useTranslation();

  const translatedItems = items.map((item: any) => ({
    ...item,
    title: t(`menu.${item.title_key}`),
    items1: item.items1
      ? item.items1.map((subItem: any) => ({
          ...subItem,
          title: t(`menu.${subItem.title_key}`),
        }))
      : [],
    items2: item.items2
      ? item.items2.map((subItem: any) => ({
          ...subItem,
          title: t(`menu.${subItem.title_key}`),
        }))
      : [],
  }));

  
  return (
    <div className="nav-body">
          <div className="nav-bodyInner">
        <Nav className="nav justify-content-center" as="ul">
          {translatedItems.map((item: INavBarItem, index: number) => (
            <NavItemComponent {...item} />
          ))}
        </Nav>
          
          </div>
        </div>
  );
}

export default MobileMenuComponent;

